import i18next from 'i18next';

import { CatalogueMenu } from 'types/api/product.type';

import { normalizeMenuKey } from 'hooks/useCatalogueLabels';

type LabelTree = { genders: Record<string, string>; categories: Record<string, string> };

/**
 * The catalogue menu carries the Italian/English label of every genre and category, as stored
 * in the database. Registering them over the bundled catalogueMenu dictionary makes every
 * useCatalogueLabels caller show the database labels; a code without a label keeps the
 * dictionary entry (or the code itself).
 */
export const registerCatalogueLabels = (menu: CatalogueMenu[]): void => {
  const labels: Record<'it' | 'en', LabelTree> = {
    it: { genders: {}, categories: {} },
    en: { genders: {}, categories: {} },
  };
  const put = (
    section: keyof LabelTree,
    code: string,
    labelIt?: string | null,
    labelEn?: string | null
  ) => {
    const key = normalizeMenuKey(code);
    if (labelIt) labels.it[section][key] = labelIt;
    if (labelEn) labels.en[section][key] = labelEn;
  };

  menu.forEach((genre) => {
    put('genders', genre.nodeName, genre.labelIt, genre.labelEn);
    genre.nodeName2.forEach((category) =>
      put('categories', category.name, category.labelIt, category.labelEn)
    );
  });

  (['it', 'en'] as const).forEach((language) => {
    i18next.addResourceBundle(
      language,
      'translation',
      { catalogueMenu: labels[language] },
      true,
      true
    );
  });
};
